import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { createStyles, FormControlLabel, FormHelperText, withStyles, Radio, RadioGroup, FormLabel, FormControl } from '@material-ui/core';

var styles = function styles() {
  return createStyles({
    label: {
      marginBottom: 4
    },
    radio: {
      padding: '5px 9px'
    }
  });
};

var CustomRadio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CustomRadio, _React$Component);

  function CustomRadio() {
    _classCallCheck(this, CustomRadio);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomRadio).apply(this, arguments));
  }

  _createClass(CustomRadio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handler = _this$props.handler,
          meta = _this$props.meta,
          hasError = _this$props.hasError,
          touched = _this$props.touched,
          status = _this$props.status,
          value = _this$props.value,
          classes = _this$props.classes;
      var isDisabled = status === 'DISABLED';
      return React.createElement(React.Fragment, null, React.createElement(FormControl, {
        margin: 'dense'
      }, !!meta.label && React.createElement(FormLabel, {
        component: 'legend',
        classes: {
          root: classes.label
        }
      }, meta.label), React.createElement(RadioGroup, Object.assign({
        name: meta.name,
        value: value
      }, handler(), {
        row: !!meta.row
      }), meta.items.map(function (item, index) {
        return React.createElement(FormControlLabel, {
          key: "radio-".concat(meta.name, "-").concat(index),
          value: item.key,
          control: React.createElement(Radio, {
            color: 'primary',
            classes: {
              root: classes.radio
            }
          }),
          label: item.value,
          disabled: isDisabled
        });
      }))), touched && hasError('required') && React.createElement(FormHelperText, {
        error: true
      }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"));
    }
  }]);

  return CustomRadio;
}(React.Component);

export default withStyles(styles, {
  name: 'CustomRadio'
})(CustomRadio);